<template>
  <button type="button" class="tooltip" @click="click">
    <Icon :name="icon"/>
  </button>
</template>
<script>
import Icon from '@/components/Icon/Icon.vue';

export default {
  components: { Icon },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  computed: {
    icon() {
      return this.data.icon || null;
    },
    text() {
      return this.data.text || '';
    },
  },
  methods: {
    click() {
      this.$emit('onClick');
    },
  },
};
</script>

<style lang="scss" scoped>
@import "Tooltip";
</style>
